/**
 * role-display — mapping ruolo → label IT + tone Badge.
 *
 * Centralizzato qui per garantire coerenza tra sidebar, topbar, tabelle
 * utenti, audit log. NON hard-codare label/tone nei componenti.
 */

import type { UserRole } from '@shared/types/auth';
import type { BadgeTone } from '@shared/components/ui/Badge';

const ROLE_LABELS: Record<UserRole, string> = {
  TITOLARE: 'Titolare',
  DIETOLOGA: 'Nutrizionista',
  SEGRETERIA: 'Segreteria',
  ADMIN: 'Admin',
  PAZIENTE: 'Paziente',
};

const ROLE_TONES: Record<UserRole, BadgeTone> = {
  TITOLARE: 'titolare',
  DIETOLOGA: 'dietologa',
  SEGRETERIA: 'segreteria',
  ADMIN: 'admin',
  PAZIENTE: 'neutral',
};

export function roleLabel(role: UserRole | null | undefined): string {
  if (!role) return '—';
  return ROLE_LABELS[role];
}

export function roleBadgeTone(role: UserRole | null | undefined): BadgeTone {
  if (!role) return 'neutral';
  return ROLE_TONES[role];
}

/**
 * Estrae il "nome di battesimo" dal displayName per saluti come
 * "Buongiorno Maria". Se manca, ripiega sull'email (parte locale).
 */
export function firstName(
  displayName: string | null | undefined,
  email?: string | null
): string {
  const dn = (displayName ?? '').trim();
  if (dn.length > 0) {
    const first = dn.split(/\s+/)[0]!;
    return first;
  }
  const e = (email ?? '').trim();
  if (e.length > 0) {
    const local = e.split('@')[0]!;
    return local.charAt(0).toUpperCase() + local.slice(1);
  }
  return 'utente';
}
